export default class Result {
  constructor() {
    this.id = "";
    this.name = "";
  }

  static validateOne(targetResult, index) {
    let validateResult = {
      isInvalid: false,
      errors: []
    }

    let result = new Object()
    // for deep copy
    Object.assign(result, targetResult)

    if(!result.hasOwnProperty('id')) {
      validateResult.isInvalid = true
      validateResult.errors.push(new Error(`results[${index}] has not id`))
    }

    // dataがない場合終了
    if(!result.hasOwnProperty('data')) {
      validateResult.isInvalid = true
      validateResult.errors.push(new Error(`results[${index}] has not data`))
      return validateResult
    }

    if(!result.data.hasOwnProperty('escapeRef')) {
      validateResult.isInvalid = true
      validateResult.errors.push(new Error(`results[${index}] has not success`))
    }

    if(!result.data.hasOwnProperty('success')) {
      validateResult.isInvalid = true
      validateResult.errors.push(new Error(`results[${index}] has not success`))
    }

    return validateResult
  }

  static validate(targetResults) {
    let validateResult = {
      isInvalid: false,
      errors: []
    }

    let length = targetResults.length
    for(let i = 0; i < length; i++) {
      let result = Result.validateOne(targetResults[i], i)
      if(result.isInvalid) {
        validateResult.isInvalid = true
        validateResult.errors.push(...result.errors)
      }
    }

    return validateResult
  }
}